import {useEffect, useState} from "react";
import {xcService} from "../../../_services/xcService";
import {useTranslation, withTranslation} from "react-i18next";
import {
    MoreOutlined,
    FolderOpenOutlined,
    FolderAddOutlined,
    SendOutlined,
    ShareAltOutlined,
    LeftOutlined
} from "@ant-design/icons";

import {v1 as uuidv1} from "uuid";
import {ShareSocial} from 'react-share-social'
import {Modal, Tag, Button, Form, Input, Spin} from "antd";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import variables from "../../../_constants/variables";
import ResourceAdminView from "./resource.admin.view";

const ResourceUserView = () => {

    const {t, i18n} = useTranslation();
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const userStorage = JSON.parse(storage.getItem(variables.USER));
    const [userData, setUserData] = useState(userStorage)
    const [resourcesData, setResourcesData] = useState();
    const [courseResources, setCourseResources] = useState();
    const [areaResources, setAreaResources] = useState();
    const [regionResources, setRegionResources] = useState();
    const [showCreateResourceModal, setShowCreateResourceModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [resourceFolders, setResourceFolders] = useState([]);
    const [currentFolder, setCurrentFolder] = useState();
    const [showCreateFolderModal, setShowCreateFolderModal] = useState(false);
    const [currentFolderItems, setCurrentFolderItems] = useState();
    const [titleResources, setTitleResources] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [link, setLink] = useState("");
    const userType = storage.getItem(variables.USER_TYPE);

    useEffect(() => {
            let mUrl = '/v1/resourcesst/web/';
            if (userType === 'STUDENT' || userType === 'FAMILY') {
                if (userType === 'FAMILY') {
                    mUrl = '/v1/resourcesfam/web/' + userData.uid + "/";
                }
            } else {
                mUrl = '/v1/resources/web/';
            }
            xcService.getToken(mUrl + userType)
                .then(({data}) => {

                    let mLinks = data.data.filter(it => {
                        return !it.userlinksroles || it.userlinksroles.length === 0 || it.userlinksroles.filter(ur => ur.role === (userType === "FAMILY" ? "STUDENT" : userType)).length > 0
                    })

                    setLoading(false)

                    setResourcesData(mLinks)
                })
            xcService.get('/v1/resources/areas')
                .then(({data}) => setAreaResources(data.data))
            xcService.get('/v1/resources/courses')
                .then(({data}) => setCourseResources(data.data))
            xcService.get('/v1/resources/region')
                .then(({data}) => setRegionResources(data.data))
            xcService.get('/v1/resources/folders')
                .then(({data}) => setResourceFolders(data.data));
            xcService.get('/v1/resources/title')
                .then(({data}) => setTitleResources(data.data));
        },
        [showCreateResourceModal])

    useEffect(() => {
        if (currentFolder) xcService.get(`/v1/resource/folders/${currentFolder}/resources`)
            .then(({data}) => setCurrentFolderItems(data.data))
    }, [currentFolder])

    const deleteResource = (id) => {
        xcService.deleteToken(`/v1/resources/${id}`).then(() =>
            xcService.get('/v1/resources')
                .then(({data}) => setResourcesData(data.data))
        )
    }

    const createFolder = (values) => {
        xcService.postToken(`/v1/resources/folders`, {
            name: values.name
        }).then(() =>
            xcService
                .get('/v1/resources/folders')
        ).then(({data}) =>
            setResourceFolders(data.data))
            .then(() => setShowCreateFolderModal(false))
    }

    const addResourceToFolder = (resourceId, folderId) => {
        xcService.postToken(`/v1/resource/folders/resource`, {resourceId, folderId})
    }

    const deleteResourceFromFolder = (resourceId, folderId) => {
        xcService.deleteToken(`/v1/resource/folders/resource`, {resourceId, folderId})
            .then(({data}) => setCurrentFolderItems(data.data))
    }

    const addToStudentFolder = (id) => {

        xcService.postToken(`/v1/${userType === "STUDENT" ? 'student' : 'tutor'}/resources/${id}`);
    }


    const showModal = (link) => {
        setLink(link);
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setLink("");
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setLink("")
        setIsModalOpen(false);
    };

    if (loading) {
        return <div className={"loaderDiv"}><Spin size={"large"} fullscreen={true} /></div>
    } else {

        return (resourcesData && courseResources && areaResources && regionResources ?
            !currentFolder ?
                <>
                    <Modal
                        open={showCreateResourceModal}
                        onOk={() => setShowCreateResourceModal(false)}
                        onCancel={() => setShowCreateResourceModal(false)}
                        footer={null}
                    >
                        <ResourceAdminView setShowModal={setShowCreateResourceModal}/>
                    </Modal>
                    <Modal
                        open={showCreateFolderModal}
                        onCancel={() => setShowCreateFolderModal(false)}
                        footer={null}
                    >
                        <Form onFinish={createFolder}>
                            <Form.Item label={t("myFolder.carpertan")} name="name">
                                <Input/>
                            </Form.Item>
                            <Form.Item wrapperCol={{offset: 8, span: 16}}>
                                <Button type="primary" htmlType="submit">
                                    {t("myFolder.crear")}
                                </Button>
                            </Form.Item>
                        </Form>
                    </Modal>
                    <div className={"container container--resources boxed boxed--admin-default"}>

                        {loading ? <>
                                <div className="custom-loader"></div>
                            </>
                            :
                            <>

                                <h1>{t("resources.title")}</h1>
                                {userType === 'MASTER' &&
                                    <Button
                                        onClick={() => setShowCreateResourceModal(true)}>{t("myFolder.addrec")}</Button>}
                                <p>{t("resources.desc")}</p>
                                <h2>{t("resources.recoresources")}</h2>
                                <div className={"container-resources-folders"}>

                                    {resourcesData.map(resource =>
                                        <div key={uuidv1()} className={"card-resources-folders is-resources"}>
                                            <div className={"card-resources-folders-top"}>
                                                <img
                                                    src={resource.image && resource.image !== "" ? resource.image : "/assets/img/noimg.png"}
                                                    alt={""} width={58} height={58}/>
                                                <div className={"card-resources-folders__content"}>
                                                    <h3 className={"card-resources-folders__title"}>{resource.name}</h3>
                                                    <p className={"card-resources-folders__description"}>{resource.description}</p>
                                                    <a className={"card-resources-folders__link"} href={resource.link}
                                                       target={"_blank"}>{resource.link}</a>
                                                </div>
                                                <div className={"card-resources-folders__menu"}>
                                                    <button className={"card-resources-folders__menu-btn"}>
                                                        <MoreOutlined/>
                                                    </button>
                                                    <div className="card-resources-folders__menu-content">
                                                        {userType !== 'MASTER' &&
                                                            <a href="#"
                                                               onClick={() => addToStudentFolder(resource.id)}><FolderAddOutlined/>{t("resources.menu.add")}
                                                            </a>
                                                        }
                                                        {userType === 'MASTER' && <>
                                                            <a href="#"
                                                               onClick={() => deleteResource(resource.id)}><SendOutlined/>{t("resources.menu.removeFrom")} {t("myFolder.recursos")}
                                                            </a>
                                                            {resourceFolders.map(folder =>
                                                                <a href="#" key={uuidv1()}
                                                                   onClick={() => addResourceToFolder(resource.id, folder.id)}><SendOutlined/>{t("resources.menu.addTo")} {folder.name}
                                                                </a>
                                                            )}
                                                        </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={"container-tags"}>
                                                {resource.course_links && resource.course_links.map(course =>
                                                    <Tag key={uuidv1()} color="magenta">{course.name}</Tag>
                                                )}
                                                {resource.area_links && resource.area_links.map(area =>
                                                    <Tag key={uuidv1()} color="blue">{area.area.name}</Tag>
                                                )}
                                                {regionResources.filter(region => region.id === resource.id).map(region =>
                                                    <Tag key={uuidv1()} color="red">{region.name}</Tag>
                                                )}
                                                {resource.degree_courses && resource.degree_courses.map(title =>
                                                    <Tag key={uuidv1()} color="green">{title.degree.title}</Tag>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <h2>{t("resources.recofolders")}</h2>
                                {userType === 'MASTER' &&
                                    <Button
                                        onClick={() => setShowCreateFolderModal(true)}>{t("myFolder.crearc")}</Button>
                                }
                                <div className={"container-resources-folders"}>

                                    {resourceFolders.map(folder =>
                                        <div key={uuidv1()} className={"card-resources-folders is-folder"}
                                             onClick={() => setCurrentFolder(folder.id)}>
                                            <FolderOpenOutlined/>
                                            <div className={"card-resources-folders__content"}>
                                                <h3 className={"card-resources-folders__title"}>{folder.name}</h3>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </>
                        }
                        {/*<h2>{t("resources.othersresources")}</h2>
            <div className={"container-resources-folders"}>
                <div className={"card-resources-folders is-folder"}>
                    <FolderOpenOutlined />
                    <div className={"card-resources-folders__content"}>
                        <h3 className={"card-resources-folders__title"}>{t("resources.fp")}</h3>
                    </div>
                </div>
                <div className={"card-resources-folders is-folder"}>
                    <FolderOpenOutlined />
                    <div className={"card-resources-folders__content"}>
                        <h3 className={"card-resources-folders__title"}>{t("resources.arte")}</h3>
                    </div>
                </div>
                <div className={"card-resources-folders is-folder"}>
                    <FolderOpenOutlined />
                    <div className={"card-resources-folders__content"}>
                        <h3 className={"card-resources-folders__title"}>{t("resources.deport")}</h3>
                    </div>
                </div>
            </div>*/}
                    </div>

                </> : <>

                    <Modal title={t("compartirrec")} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>

                        <ShareSocial
                            url={link}
                            socialTypes={['facebook', 'twitter', 'reddit', 'linkedin', 'whatsapp', 'email']}
                        />
                    </Modal>

                    <div className={"container container--resources boxed boxed--admin-default"}>
                        {loading ? <>
                                <div className="custom-loader"></div>
                            </>
                            :
                            <>
                                <a className={"resources-back"}
                                   onClick={() => setCurrentFolder(null)}><LeftOutlined/> {t("myFolder.backr")}</a>
                                <h1>{resourceFolders.find(folder => folder.id === currentFolder).name}</h1>
                                <div className={"container-resources-folders"}>

                                    {resourcesData.map(resource => currentFolderItems?.map(item => item.user_links_id)?.includes(resource.id) &&
                                        <div key={uuidv1()} className={"card-resources-folders is-resources"}>
                                            <div className={"card-resources-folders-top"}>
                                                <img src={resource.image ? resource.image : "/assets/img/noimg.png"}
                                                     alt={""}
                                                     width={58} height={58}/>
                                                <div className={"card-resources-folders__content"}>
                                                    <h3 className={"card-resources-folders__title"}>{resource.name}</h3>
                                                    <p className={"card-resources-folders__description"}>{resource.description}</p>
                                                    <a className={"card-resources-folders__link"} href={resource.link}
                                                       target={"_blank"}>{resource.link}</a>
                                                </div>
                                                <div className={"card-resources-folders__menu"}>
                                                    <button className={"card-resources-folders__menu-btn"}><MoreOutlined/>
                                                    </button>
                                                    <div className="card-resources-folders__menu-content">
                                                        {userType === 'STUDENT' &&
                                                            <a href="#"
                                                               onClick={() => addToStudentFolder(resource.id)}><FolderAddOutlined/>{t("resources.menu.add")}
                                                            </a>
                                                        }
                                                        {userType === 'MASTER' && <>
                                                            <a href="#"
                                                               onClick={() => deleteResource(resource.id)}><SendOutlined/>{t("resources.menu.removeFrom")} {t("myFolder.recursos")}
                                                            </a>
                                                            <a href="#"
                                                               onClick={() => deleteResourceFromFolder(resource.id, currentFolder)}><SendOutlined/>{t("resources.menu.removeFrom")} {resourceFolders.find(folder => folder.id === currentFolder).name}
                                                            </a>
                                                        </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={"container-tags"}>
                                                {courseResources.filter(course => course.id === resource.id).map(course =>
                                                    <Tag color="magenta">{course.name}</Tag>
                                                )}
                                                {areaResources.filter(area => area.id === resource.id).map(area =>
                                                    <Tag color="blue">{area.name}</Tag>
                                                )}
                                                {regionResources.filter(region => region.id === resource.id).map(region =>
                                                    <Tag color="red">{region.name}</Tag>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </>
                        }
                    </div>
                </> : <></>)
    }
}

export default withTranslation()(ResourceUserView);
